import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { FaxTypeOption } from 'src/app/pages/fax-register/models/fax-type-option.interface';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { faxTypeOptionActions } from '../state/fax-type-option.actions';
import { faxTypeOptionSelectors } from '../state/fax-type-option.reducer';

@Directive({
    selector: '[ndtfaxTypeSelect]',
    standalone: false
})
export class FaxTypeSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<FaxTypeOption>,
      private statusService: NgrxEagerSelectService<AppState, FaxTypeOption>
   ) {}

   ngAfterViewInit(): void {
      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            faxTypeOptionActions,
            faxTypeOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('typeName', this.trigger);
            },
            undefined
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
